import { RocketLaunchIcon, SquaresPlusIcon } from "@heroicons/react/24/outline";

const AirlineBooking = [
    {
        path: "airline-booking",
        fullPath: "call-center/airline-booking",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Airline Booking",
        displayPath: "Call Center > Airline Booking",
        icon: RocketLaunchIcon,
        children: [
            {
                path: "manage",
                fullPath: "call-center/airline-booking/manage",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Manage",
                displayPath: "Call Center > Airline Booking > Manage",
                icon: SquaresPlusIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Manage/Airline"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-airline-booking-manage"],
                    },
                ],
            },
        ],
    },
];

export default AirlineBooking;
